import React, { useState, useEffect,useRef } from "react";
import { MdOutlineSchedule, MdAdd, MdSearch,MdGroup,MdCake,MdMessage,MdPayments,MdPrivacyTip,MdSend} from "react-icons/md";
import { styles } from "../styles/ScheduledListPage.styles";
import { getAgendamentos } from "../services/agendamento";
import { useAuth } from "../context/AuthContext";
import {formatDateAGEND,formatCobrancaMensagem} from "../utils/utils";
import { useNavigate } from "react-router-dom";

function ScheduledListPage({setActiveMenu, setSelectedAgendamento}) {
  const [isMobile, setIsMobile] = useState(
    typeof window !== "undefined" ? window.innerWidth < 768 : false
  );

  const [search, setSearch] = useState("");
  const [debouncedSearch, setDebouncedSearch] = useState("");
  const [sortOrder, setSortOrder] = useState("desc");
  const [appointments, setAppointments] = useState([]);
  const { token } = useAuth();
  const [loading, setLoading] = useState(false);
  const [imgError, setImgError] = useState({});
  const [hasMore, setHasMore] = useState(true);
  const [loadingMore, setLoadingMore] = useState(false);
  const containerRef = useRef(null);
  const [initialLoaded, setInitialLoaded] = useState(false);
  const loadingRef = useRef(false);
  const scrollTimeoutRef = useRef(null);
  const navigate = useNavigate();
  const [loadedImages, setLoadedImages] = useState({});
  const faseColor = {
    ANTES: "#2563eb",   // azul
    DIA: "#f59e0b",     // amarelo/laranja
    ATRASO: "#dc2626"   // vermelho
 };


  const sortByDateDesc = (list) =>
  [...list].sort((a, b) =>
    b.DATA_AGEND.localeCompare(a.DATA_AGEND)
  );


  const mergeAndSort = (prev, incoming) => {
  const all = [...prev, ...(incoming || [])];

  const unique = Object.values(
    all.reduce((acc, item) => {
      acc[item.STAMP] = item;
      return acc;
    }, {})
  );

  return sortByDateDesc(unique);
};
  
  
  const handleEditAgendamento = (item) => {
    if (item.ESTADO === "agendada") {
      if (setSelectedAgendamento) {
        setSelectedAgendamento(item);
      }
      navigate("/agendar/editar");
    }
  };


  useEffect(() => {
    if (!appointments.length) return;

    let isMounted = true;

    const preloadImages = async () => {
      const promises = appointments.map((item) => {
        return new Promise((resolve) => {
          if (!item.DESTINO_FOTO) {
            resolve();
            return;
          }

          const img = new Image();

          img.src = item.DESTINO_FOTO;

          img.onload = () => resolve();
          img.onerror = () => resolve();
        });
      });

      await Promise.all(promises);
    };

    preloadImages();

    return () => {
      isMounted = false;
    };
  }, [appointments]);



  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // Debounce do search
  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedSearch(search);
    }, 500);

    return () => clearTimeout(timer);
  }, [search]);

  
  useEffect(() => {
    const fetchAgendamentos = async () => {
        if (!token) return;
        setLoading(true);

        try {
        const data = await getAgendamentos(20);
        const sorted = (data?.agendamentos || []).sort((a, b) =>
            b.DATA_AGEND.localeCompare(a.DATA_AGEND)
        );

        setAppointments(sortByDateDesc(data?.agendamentos || []));
        setHasMore(data?.hasMore);
   

        setInitialLoaded(true);
        } catch (err) {
        console.error("Erro ao buscar agendamentos:", err);
        } finally {
        setLoading(false);
        }
    };

    fetchAgendamentos();
}, [token]);

  const loadMore = async () => {
  if (!hasMore || loadingRef.current) return;

  loadingRef.current = true;
  setLoadingMore(true);

  try {
    const lastItem = appointments[appointments.length - 1];

    const data = await getAgendamentos(
      20,
      lastItem.DATA_AGEND,
      lastItem.STAMP
    );

    setAppointments(prev => {
      const merged = [...prev, ...(data?.agendamentos || [])];

      const unique = Object.values(
        merged.reduce((acc, item) => {
          acc[item.STAMP] = item;
          return acc;
        }, {})
      );

      return sortByDateDesc(unique);
    });

    setHasMore(data?.hasMore);
  } catch (err) {
    console.error("Erro ao carregar mais:", err);
  } finally {
    loadingRef.current = false;
    setLoadingMore(false);
  }
};

  useEffect(() => {
    const handleScroll = () => {
        const el = containerRef.current;
        if (!el) return;

        const isBottom =
        el.scrollTop + el.clientHeight >= el.scrollHeight - 200;

        if (isBottom && !scrollTimeoutRef.current) {
          scrollTimeoutRef.current = setTimeout(async () => {
            scrollTimeoutRef.current = null;
            await loadMore();
          }, 300); // Debounce de 300ms
        }
    };

    const el = containerRef.current;
    if (!el) return;

    el.addEventListener("scroll", handleScroll);

    return () => {
      el.removeEventListener("scroll", handleScroll);
      if (scrollTimeoutRef.current) {
        clearTimeout(scrollTimeoutRef.current);
      }
    };
    }, [appointments, hasMore, loadingMore]); 

    const filteredAppointments = appointments
      .filter((item) => {
        const text = debouncedSearch.toLowerCase();

        return (
          item.CONTEUDO?.toLowerCase().includes(text) ||
          item.DESTINO_NOME?.toLowerCase().includes(text)
        );
      })
     .sort((a, b) => {
        if (sortOrder === "asc") {
          return a.DATA_AGEND.localeCompare(b.DATA_AGEND); 
        } else {
          return b.DATA_AGEND.localeCompare(a.DATA_AGEND); 
        }
      });
      
   

   const groupedAppointments = filteredAppointments.reduce(
    (acc, item) => {
        let key;
        if (item.ESTADO === "enviada") {
            key = "enviada";
        } else if (item.TIPO === "campanha") {
            key = "recorrente";
        } else {
            key = "personalizado";
        }

        if (!acc[key]) acc[key] = [];
        acc[key].push(item);

        return acc;
    },
    {}
    ); 

    

  return (
    <div ref={containerRef} style={styles.page(isMobile)}>
      <div style={styles.headerRow(isMobile)}>
        <div style={styles.iconBadge(isMobile)}>
          <MdOutlineSchedule size={isMobile ? 20 : 22} />
        </div>

        <div>
          <h2 style={styles.title(isMobile)}>Agendamentos</h2>
          <p style={styles.subtitle(isMobile)}>Lista de agendamentos.</p>
        </div>
      </div>

      <div style={styles.card(isMobile)}>
         {loading && (
            <div style={styles.loadingOverlay(isMobile)}>
                <div style={styles.spinner(isMobile)} />
            </div>
        )}
        <div style={styles.sectionHeader(isMobile)}>
          <div>
            <h3 style={styles.cardTitle(isMobile)}>Próximos agendamentos</h3>
            <p style={styles.cardDescription(isMobile)}>
              Visualize apenas os agendamentos disponíveis.
            </p>
          </div>
        </div>

        <div style={styles.toolbarContainer(isMobile)}>
          <div style={styles.searchWrapper(isMobile)}>
            <MdSearch size={isMobile ? 16 : 18} style={styles.searchIcon(isMobile)} />
            <input
              type="text"
              placeholder="Pesquisar agendamentos..."
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              style={styles.searchInput(isMobile)}
            />
          </div>

          <div style={styles.toolbarActions(isMobile)}>
            <select
              value={sortOrder}
              onChange={(e) => setSortOrder(e.target.value)}
              style={styles.sortSelect(isMobile)}
            >
              <option value="desc">Mais Recentes</option>
              <option value="asc">Mais Antigos</option>
            </select>

            <button style={styles.addButton(isMobile)}  onClick={() => navigate("/agendar/novo")}>
                
              <MdAdd size={isMobile ? 18 : 20} style={styles.addButtonIcon(isMobile)} />
              Adicionar
            </button>
          </div>
        </div>

        {filteredAppointments.length === 0 ? (
        <div style={styles.emptyState(isMobile)}>
          <MdOutlineSchedule size={48} style={{ color: "#cbd5e1" }} />
          <p style={styles.emptyMessage}>
            Nenhum agendamento encontrado
          </p>
        </div>
      ) : (

        ["personalizado", "recorrente", "enviada"].map((groupKey) => {
        const group = groupedAppointments[groupKey];

        if (!group || group.length === 0) return null;

        return (
            <div key={groupKey} style={{ marginBottom: 28 }}>
            
            {/* HEADER DO GRUPO */}
            <h3 style={{
                fontSize: 14,
                color: "#1f3a70",
                margin: "10px 0",
                fontWeight: 700,
                textTransform: "uppercase"
            }}>
                {groupKey === "enviada" ? "Enviados" : 
                 groupKey === "recorrente" ? "Recorrentes" : "Personalizados"}
            </h3>

            {/* LISTA */}
            {group.map((item) => (
                <div 
                  key={item.STAMP} 
                  style={{
                    ...styles.appointmentItem(isMobile),
                    backgroundColor: "transparent",
                    ...(item.ESTADO === "agendada" ? { 
                      cursor: "pointer",
                      transition: "background-color 0.2s ease"
                    } : {})
                  }}
                  onClick={() => handleEditAgendamento(item)}
                  onMouseEnter={(e) => {
                    if (item.ESTADO === "agendada") {
                      e.currentTarget.style.backgroundColor = "#f3f4f6";
                    }
                  }}
                  onMouseLeave={(e) => {
                    if (item.ESTADO === "agendada") {
                      e.currentTarget.style.backgroundColor = "transparent";
                    }
                  }}
                >

                <div
                  style={{
                    position: "relative",
                    width: isMobile ? 48 : 56,
                    height: isMobile ? 48 : 56,
                    minWidth: isMobile ? 48 : 56,
                    flexShrink: 0,
                  }}
                >
                  {item.DESTINO_FOTO && !imgError[item.STAMP] ? (
                    <>
                      {!loadedImages[item.STAMP] && (
                        <div
                          style={{
                            position: "absolute",
                            inset: 0,
                            borderRadius: 12,
                            border: "2px solid rgba(31, 58, 112, 0.1)",
                            background:
                              "linear-gradient(90deg, #e5e7eb 25%, #f3f4f6 50%, #e5e7eb 75%)",
                            backgroundSize: "200% 100%",
                            animation: "shimmer 1.2s infinite",
                          }}
                        />
                      )}

                      <img
                        src={item.DESTINO_FOTO}
                        alt={item.DESTINO_NOME}
                        style={{
                          ...styles.appointmentPhoto(isMobile),
                          position: "absolute",
                          inset: 0,
                          opacity: loadedImages[item.STAMP] ? 1 : 0,
                          transition: "opacity 0.25s ease",
                        }}
                        onLoad={() =>
                          setLoadedImages((prev) => ({
                            ...prev,
                            [item.STAMP]: true,
                          }))
                        }
                        onError={() =>
                          setImgError((prev) => ({
                            ...prev,
                            [item.STAMP]: true,
                          }))
                        }
                      />
                    </>
                  ) : (
                    <div
                      style={{
                        ...styles.appointmentPhotoFallback(isMobile),
                        position: "absolute",
                        inset: 0,
                      }}
                    >
                      <MdGroup size={isMobile ? 20 : 24} />
                    </div>
                  )}
                </div>
              
                <div style={styles.appointmentContent(isMobile)}>
                    <div style={styles.appointmentHeader(isMobile)}>
                    <div style={{ minWidth: 0 }}>
                        <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                        {item.CAMPANHA_NOME === "Aniversário" ? (
                        <MdCake size={isMobile ? 16 : 18} color="#f59e0b" />
                        ) : item.CAMPANHA_NOME === "Cobranças" ? (
                        <MdPayments size={isMobile ? 16 : 18} color="#dc2626" />
                        ) : item.CAMPANHA_NOME === "Mensagem" ? (
                        <MdMessage size={isMobile ? 16 : 18} color="#3b82f6" />
                        ) : item.CAMPANHA_NOME === "Privacidade" ? (
                        <MdPrivacyTip size={isMobile ? 16 : 18} color="#8b5cf6" />
                        ) : (
                        <MdSend size={isMobile ? 16 : 18} color="#10b981" />
                        )}

                        <h4 style={styles.appointmentTitle(isMobile)}>
                            {item.CAMPANHA_NOME || "Mensagem Agendada"}
                        </h4>
                        </div>

                        <p style={styles.appointmentRecipient(isMobile)}>
                        {item.DESTINO_NOME}
                        </p>
                    </div>

                    <div style={{ display: "flex", gap: 8, marginLeft: "auto" }}>
                        <span style={styles.typeBadge(item.TIPO, isMobile)}>
                        {item.TIPO === "campanha" ? "Recorrente" : "Personalizado"}
                        </span>

                        <span style={styles.statusBadge(item.ESTADO, isMobile)}>
                        {item.ESTADO === "enviada" ? "Enviado" : "Agendado"}
                        </span>
                    </div>
                    </div>

                  <p style={styles.appointmentDescription(isMobile)}>
                    {item.CAMPANHA_NOME === "Cobranças"
                      ? (() => {
                          const data = formatCobrancaMensagem(item.CONTEUDO);

                          const color = faseColor[data.fase] || "#6b7280";

                          return (
                            <>
                              <div
                                style={{
                                  fontSize: 12,
                                  color,
                                  marginBottom: 6,
                                  fontWeight: 600,
                                  display: "flex",
                                  alignItems: "center",
                                  gap: 6
                                }}
                              >
                                <span
                                  style={{
                                    width: 8,
                                    height: 8,
                                    borderRadius: "50%",
                                    background: color,
                                    display: "inline-block"
                                  }}
                                />
                                Fase: <b>{data.faseLabel}</b>
                              </div>

                              <div
                                style={{
                                  whiteSpace: "pre-wrap",
                                  color: "#111827"
                                }}
                              >
                                {data.mensagem}
                              </div>
                            </>
                          );
                        })()
                      : item.CONTEUDO}
                  </p>
                </div>

                <span style={styles.appointmentMeta(isMobile)}>
                    {formatDateAGEND(item.DATA_AGEND)}
                </span>
                </div>
            ))}
            </div>
        );
       })
    )}

        {loadingMore && (
        <div style={{
            display: "flex",
            justifyContent: "center",
            padding: "12px 0"
        }}>
            <div style={styles.spinnerSmall(isMobile)} />
        </div>
        )}

        {!hasMore && appointments.length > 0 && (
        <div style={{
            textAlign: "center",
            padding: "10px 0",
            fontSize: 12,
            color: "#999"
        }}>
            Não há mais agendamentos
        </div>
        )}       

      </div>
   </div>
  );
}

export default ScheduledListPage;